export default __webpack_public_path__ + "static/media/image-check-gestalt.6432f432.svg";